export const INTERIMAIRE_REGISTER_BY_MOBILE = "INTERIMAIRE_REGISTER_BY_MOBILE";
export const INTERIMAIRE_REGISTER_BY_MOBILE_SUCCESS =
  "INTERIMAIRE_REGISTER_BY_MOBILE_SUCCESS";
export const INTERIMAIRE_REGISTER_BY_MOBILE_ERROR =
  "INTERIMAIRE_REGISTER_BY_MOBILE_ERROR";
